import React from 'react';
import axios from 'axios';
import { Link, withRouter } from 'react-router-dom';
import UserProductStatus from '../../component/UserProductStatus';
import Pagination from '../../component/Pagination';
import ProductName from './ProductName';
import { connect } from 'react-redux';
import ChangeUserModal from './modals/ChangeUserModal';
import moment from 'moment';
import { RenderSearchForm } from '../../component/formInput';
import IPModifyModal from './modals/IPModifyModal';
import { Field, reduxForm } from 'redux-form';
import { ToastContainer, toast } from 'react-toastify';
import ExpiredModifyModal from './modals/ExpiredModifyModal';
import { RolePath, ServicePageRole } from '../../component/UserPermission';
import BlockUI from '../../component/BlockUI';
import { StringUtils } from '../../utils/javascriptUtils';
import SuspendServiceExpiredModal from './modals/SuspendServiceExpiredModal';
import SuspendManualModal from './modals/SuspendManualModal';
import FinishTransferModal from './modals/FinishTransferModal';
var _ = require('lodash');

const mapState = state => ({
  cart: state.cart,
  role_path: state.userProfile.role_path,
  userProfile: state.userProfile.data
});

const mapDispatch = (dispatch) => ({
  addItem: (item) => dispatch.cart.addItem(item),
  setNote: (note) => dispatch.cart.setNote(note),
  updateCart: () => dispatch.cart.updateCart()
});

function IsServiceExpired(user_product) {
  const now = moment();
  const expired = moment(user_product.expired);
  const duration = Math.round(expired.diff(now, "days", true));
  return duration <= 0;
}

// Cấu hình Hosting
function hostingConfigDropbox(user_product, handleHostingConfig) {
  return (
    <a key={"HOSTING_KEY_" + user_product.id} onClick={()=>handleHostingConfig(user_product)} className="dropdown-item">
      <i className="icon-gear"></i> Cấu hình (Cpanel hoặc Plesk)
    </a>
  )
}

// Cấu hình DNS cho Domain
function DNSConfigDropbox(role_path, user_product, dnsDirectUrl) {
  return (
    <React.Fragment key={"DNS_KEY_" + user_product.id}>
      <a onClick={()=>dnsDirectUrl(user_product.domain)} className="dropdown-item">
        <i className="icon-circle-right2"></i> Cấu hình DNS
      </a>
    </React.Fragment>
  )
}

// Chi tiết bản khai tên miền cho dịch vụ domain
function DomainProfileDropbox(role_path, user_product) {
  return (
    <React.Fragment key={"DOMAIN_KEY_" + user_product.id}>
      <Link to={role_path + "/customer/profile/detail/" + user_product.domain_profile_id} className="dropdown-item">
        <i className="icon-profile"></i> Bản khai
      </Link>
    </React.Fragment>
  )
}

// Mục quản lý VPS.
function VPSManageDropbox(role_path, user_product) {
  return (
    <React.Fragment key={"VPS_KEY_" + user_product.id}>
      <Link to={role_path + "/vps/config/" + user_product.id} className="dropdown-item">
        <i className="icon-file-presentation"></i> Quản lý dịch vụ
      </Link>
    </React.Fragment>
  )
}

function AddonService(user_product, addon_services, showIPModifyModal, onRemoveWhoIsPrivacy) {
  const whois_addon_item = _.find(addon_services, (i) => i.product.product_type == "WHOIS_PRIVACY" && i.parent_id === user_product.id);
  const ip_addon_item = _.filter(addon_services, (i) => i.product.product_type == "IP" && i.parent_id === user_product.id);
  const mouse_cursor_style = {color:"#42A5F5", cursor: 'pointer'};
  let inner_addon_service = null;
  if(whois_addon_item) {
    inner_addon_service = <React.Fragment>
      <small style={{color: 'orange'}}>+ Whois Privacy</small>
      <small style={mouse_cursor_style} onClick={()=>onRemoveWhoIsPrivacy(whois_addon_item.id)}> [ Rút Lại ]</small>
    </React.Fragment>
  }
  if(ip_addon_item.length > 0) {
    inner_addon_service = (
      <small style={{ color: "orange" }} >
        {_.map(ip_addon_item, (i) => 
          <span>IP: {i.ip_address} 
          <span style={mouse_cursor_style} onClick={() => showIPModifyModal(i, "ADDON")} > [Chỉnh sửa] </span>
          <br/>
          </span>
        )}
      </small>
    )
  }
return inner_addon_service;
}

function ExpiredSuspendItem(user_product, onSuspendServiceExpired) {
  return (
    <React.Fragment>
      <button onClick={() => onSuspendServiceExpired(user_product)} className="dropdown-item" ><i className="icon-cancel-circle2"></i>Suspend Do Hết Hạn</button>
    </React.Fragment>
  )
}

function SuspendManualItem(user_product, onSuspendServiceManual) {
  return (
    <React.Fragment>
      <button onClick={() => onSuspendServiceManual(user_product)} className="dropdown-item" ><i className="icon-stop"></i>Suspend Manual</button>
    </React.Fragment>
  )
}

function FinishTransferDomain(user_product, onFinishTransfer) {
  return (
    <React.Fragment>
      <button onClick={() => onFinishTransfer(user_product)} className="dropdown-item" ><i className="icon-color-sampler"></i>Hoàn tất transfer</button>
    </React.Fragment>
  )
}

function ServiceDropbox(userProfile ,role_path, item, onExpiredModify, handleHostingConfig, onSuspendServiceExpired, onSuspendServiceManual, onFinishTransfer, dnsDirectUrl) {
  return (
    <React.Fragment>
      {/* <Link className="dropdown-item" to={"/admin/related-invoice"}><i className="icon-clipboard3"></i>Đơn Hàng Liên Quan</Link> */}
      {userProfile && ServicePageRole.isShowHistory(userProfile.role) && <Link className="dropdown-item" to={role_path + "/service/history/" + item.id}><i className="icon-history"></i>Lịch Sử Tương Tác</Link>}
      {userProfile && ServicePageRole.isExpiredDateModify(userProfile.role) && <button onClick={() => onExpiredModify(item)} className="dropdown-item" ><i className="icon-pencil7"></i>Chỉnh sửa ngày hết hạn</button>}
      {item.product && ["LINUX_HOSTING", "WINDOW_HOSTING"].includes(item.product.product_type) && ServicePageRole.isLoginHostingConfig(userProfile.role) && hostingConfigDropbox(item, handleHostingConfig)}
      {item.status != "PENDING_TRANSFER" && item.product && ["VN_DOMAIN", "COM_DOMAIN"].includes(item.product.product_type) && ServicePageRole.isDNSConfig(userProfile.role) && DNSConfigDropbox(role_path, item, dnsDirectUrl)}
      {item.product && ["VN_DOMAIN", "COM_DOMAIN"].includes(item.product.product_type) && ServicePageRole.isShowDomainProfile(userProfile.role) && DomainProfileDropbox(role_path, item)}
      {/* {item.product && ["CLOUD_SERVER_PRO", "VPS"].includes(item.product.product_type) && ServicePageRole.isVPSManage(userProfile.role) && VPSManageDropbox(role_path, item)} */}
      {item.status == "RUNNING" && IsServiceExpired(item) && ServicePageRole.isAllowExpiredSuspend(userProfile.role) && ExpiredSuspendItem(item, onSuspendServiceExpired)}
      {["RUNNING", "EXPIRED"].includes(item.status) && ServicePageRole.isAllowSuspendManual(userProfile.role) && SuspendManualItem(item, onSuspendServiceManual)}
      {item.status == "PENDING_TRANSFER" && ServicePageRole.isAllowFinishTransfer(userProfile.role) && FinishTransferDomain(item, onFinishTransfer)}
    </React.Fragment>
  );
}

class UserProductRows extends React.Component {
  render() {
    const { user_product_list, table_query, role_path, userProfile, reload, showIPModifyModal } = this.props;
    const { onRemoveWhoIsPrivacy, onExpiredModify, handleHostingConfig, onSuspendServiceExpired, onSuspendServiceManual } = this.props;
    const { onFinishTransfer, dnsDirectUrl } = this.props;

    const inner_user_product_rows = user_product_list.map((user_product, key) => {
      const user_agency = user_product.user && user_product.user.agency;
      return (
        !user_product.parent_id && <tr key={key}>
          <td>
            {user_product.user && user_product.user.email}
            <br/>
            {user_agency && !user_agency.has_custom_brand && <small className="text-muted"> Đại lý: {user_agency.agency_admin.email}</small>}
            {user_agency && user_agency.has_custom_brand && <small className="text-muted"> Thương hiệu riêng: {user_agency.agency_admin.email}</small>}
            {!user_agency && <small className="text-muted"> Khách lẻ</small>}
          </td>
          <td>
            {user_product.user && user_product.user.sale ? user_product.user.sale.email : "N/A"}
            <br/>
            <small className="text-muted">{user_product.user && user_product.user.sale && user_product.user.sale.full_name}</small>
          </td>
          <td>
          {user_product.server_ip_address && <span>
              {user_product.server_ip_address}
              <span onClick={() => showIPModifyModal(user_product, "SERVER")} style={{color:"#42A5F5", cursor: 'pointer'}}> [sửa] </span>
            </span>}
          </td>
          <td>
            <ProductName key={key} reload={reload} tableQuery={table_query} userProduct={user_product}/>
            {AddonService(user_product, user_product.service_addons, showIPModifyModal, onRemoveWhoIsPrivacy)}
          </td>
          <td>{UserProductStatus(user_product)}</td>
          <td>{moment(user_product.registered).format("DD-MM-YYYY HH:mm:ss")}</td>
          <td>{moment(user_product.expired).format("DD-MM-YYYY HH:mm:ss")}</td>
          <td>
            <div className="icons-list">
              <div className="dropdown">
                <a href="#" className="list-icons-item" data-toggle="dropdown">
                  <i className="icon-menu9"></i>
                </a>
                <div className="dropdown-menu dropdown-menu-right">
                  {ServiceDropbox(userProfile, role_path, user_product, onExpiredModify, handleHostingConfig, onSuspendServiceExpired, onSuspendServiceManual, onFinishTransfer, dnsDirectUrl)}
                </div>
              </div>
            </div>
          </td>
        </tr>
      )
    })
    return inner_user_product_rows;
  }
}
const UserProductWrapper = connect(mapState, mapDispatch)(UserProductRows);

class ServicePage extends React.Component {

  constructor(props) {
    super(props);
    const {productType} = this.props.routeProps.match.params;
    const { service_status } = this.props;
    const search_value = new URLSearchParams(this.props.location.search).get("search")
    this.state = {
      table_data: [],
      table_query: {
        current_page: 1,
        number_of_row: 30,
        sort_by: "",
        sort_asc: false,
        search_field: "search",
        search_value: search_value ? search_value : "",
        status: service_status,
        ip_type: null
      },
      is_loading: true,
      service_checked_list: [],
      is_show_modal_change_user: false,
      user_product_selected: {},
      is_show_ip_modify_modal: false,
      is_show_expired_date_modal: false,
      is_show_suspend_service_expired_modal: false,
      is_show_suspend_manual_modal: false,
      is_show_finish_transfer_modal: false
    }
  }

  componentDidMount() {
    this.reload(this.state.table_query);
  }

  gotoPage = (page) => {
    const table_query = {
      ...this.state.table_query,
      current_page: page
    };
    this.reload(table_query);
  }

  reload = (table_query) => {
    const self = this;
    axios({
      method: 'post',
      url: window.api_url + '/admin/api/service/list',
      withCredentials: true,
      data: table_query
    }).then(function (response) {
      self.setState({
        ...self.state,
        is_loading: false,
        table_query: table_query,
        table_data: response.data.data
      })
    });
  }

  onSearchTxtChange = (event) => {
    const table_query = {
      ...this.state.table_query,
      search_value: event.target.value,
      current_page: 1,
    };

    this.setState({
      ...this.state,
      table_query: table_query
    });
  }

  onSearchSubmit = (values) => {
    const { history } = this.props;
    const { service_status, role_path } = this.props;
    const search_value = values.search ? values.search : "";
    const table_query = {
      ...this.state.table_query,
      search_value: search_value,
      current_page: 1
    };
    if (!StringUtils.isEmptyOrSpaces(search_value)) {
      history.push(role_path + "/service/" + service_status +"?search=" + search_value);
    } else {
      history.push("running")
    }
    this.reload(table_query);
  }

  showChangeUserModal = (user_product) => {
    this.setState({
      is_show_modal_change_user: true,
      user_product_selected: user_product
    })
  }

  // Mở Modal chỉnh sửa IP.
  showIPModifyModal = (user_product, ip_type) => {
    this.setState({
      is_show_ip_modify_modal: true,
      user_product_selected: user_product,
      ip_type: ip_type
    })
  }

  // Rút lại whois của dịch vụ khách hàng.
  onRemoveWhoIsPrivacy = (whois_service_id) => {
    const self = this;
    const { table_query } = this.state;
    const alert_confirm = window.confirm("Bạn có chắc sẽ rút WHOIS PRIVACY Addon ?");
    if(alert_confirm) {
      axios({
        method: 'post',
        url: window.api_url + '/admin/api/service/remove_whois_addon',
        withCredentials: true,
        data: {
          whois_service_id
        }
      }).then(function (response) {
        if(!response.data.isError) {
          toast.success("Rút lại WhoIs Privacy Thành Công !");
        }else {
          toast.error("Có lỗi xẫy ra !");
        }
        self.reload(table_query);
      });
    }
  }

  onExpiredModify = (user_product) => {
    this.setState({
      is_show_expired_date_modal: true,
      user_product_selected: user_product
    })
  }

  // Handle redirect sang màn hình cấu hình Hosting.
  handleHostingConfig = (user_product) => {
    let url = '/api/user/service/cpanel/manage'
    // Nếu Hệ điều hành của Hosting là window.
    // Nơi cấu hình sẽ là plesk
    if (user_product.product.product_type == "WINDOW_HOSTING") {
      url = '/api/user/service/plesk/manage'
    }
    axios({
      method: 'post',
      url: window.api_url + url,
      withCredentials: true,
      data: {
        user_product_id: user_product.id
      }
    }).then(function (response) {
      if(!response.data.isError && response.data.data != null) {
        window.open(response.data.data,"_blank");
      }else {
        toast.error("Không thể chuyển đến trang cấu hình Hosting ! Vui lòng kiểm tra lại dịch vụ !")
      }
    });
  }

  hideModal = () => {
    this.setState({
      is_show_modal_change_user: false,
      is_show_ip_modify_modal: false,
      is_show_expired_date_modal: false,
      is_show_suspend_service_expired_modal: false,
      is_show_suspend_manual_modal: false,
      is_show_finish_transfer_modal: false
    })
    this.reload(this.state.table_query);
  }

  clearDataFilter = () => {
    const { reset } = this.props;
    const table_query = {
      ...this.state.table_query,
      search_value: "",
      current_page: 1,
    };
    
    reset();
    this.reload(table_query);
  }

  onKeyPess = (key_code) => {
    const { history } = this.props;
    if (key_code == "Escape") {
      history.push("running")
      this.clearDataFilter();
    }
  }

  // Suspend dịch vụ do hết hạn.
  onSuspendServiceExpired = (user_product) => {
    this.setState({
      is_show_suspend_service_expired_modal: true,
      user_product_selected: user_product
    })
  }

  // Suspend dịch vụ thủ công.
  onSuspendServiceManual = (user_product) => {
    this.setState({
      is_show_suspend_manual_modal: true,
      user_product_selected: user_product
    })
  }

  // Suspend dịch vụ thủ công.
  onFinishTransfer = (user_product) => {
    this.setState({
      is_show_finish_transfer_modal: true,
      user_product_selected: user_product
    })
  }
  // Suspend dịch vụ thủ công.
  onSuspendServiceManual = (user_product) => {
    this.setState({
      is_show_suspend_manual_modal: true,
      user_product_selected: user_product
    })
  }

  dnsDirectUrl = (domain) => {
    axios({
      method: 'post',
      url: window.api_url + '/api/user/service/dns/manage/' + domain,
      withCredentials: true
    }).then(function (response) {
      if(!response.data.isError) {
        const sdns_login_url = "https://sdns.vn/rest/domain/" + domain + "/login/" + response.data.data;
        window.open(sdns_login_url, '_blank', 'noopener');
      }
    });
  }

  render() {
    const { table_query, table_data, role_path, is_show_modal_change_user} = this.state;
    const { is_show_ip_modify_modal, user_product_selected, is_show_expired_date_modal, ip_type} = this.state;
    const { is_loading, is_show_suspend_service_expired_modal, is_show_suspend_manual_modal, is_show_finish_transfer_modal } = this.state;
    const { title, handleSubmit, userProfile } = this.props;
    return(
      <React.Fragment>
        {is_loading && <BlockUI />}
        <ToastContainer />  
        <div className="page-header">
          <div className="page-header-content header-elements-md-inline">
            <div className="page-title d-flex">
              <h4>
                <i className="icon-paragraph-justify2 mr-2"></i>
                <span className="text-semibold">{title}</span>
              </h4>
            </div>
          </div>
        </div>
        <br/>
        <div className="row">
          <div className="col-md-12">
            <div className="card card-body">
              <form style={{display:"inline-flex"}} onSubmit={handleSubmit(this.onSearchSubmit)}>
                <div style={{ width:"100%", paddingRight:5}}>
                  <Field
                    name="search"
                    placeholder="Tên miền, IP, tên VPS"
                    defaultValue = {table_query.search_value}
                    onKeyAction={(ev)=> this.onKeyPess(ev)}
                    component={RenderSearchForm}
                  />
                </div>
              </form>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <div className="card">
              <div className="table-responsive-sm">
                <table className="table table-togglable table-hover default footable-loaded footable">
                  <thead>
                    <tr>
                      <th data-toggle="true">Thông tin khách hàng</th>
                      <th data-toggle="true">Sale</th>
                      <th data-toggle="true">Server</th>
                      <th data-toggle="true">Dịch vụ</th>
                      <th data-hidden="phone">Trạng thái</th>
                      <th data-hidden="phone">Ngày tạo</th>
                      <th data-hidden="phone">Ngày hết hạn</th>
                      <th className="text-center footable-visible footable-last-column" style={{width: "30px"}}>
                        <i className="icon-menu-open2"></i>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {table_data.data && <UserProductWrapper
                      user_product_list = {table_data.data}
                      table_query = {table_query}
                      reload = {this.reload}
                      showChangeUserModal = {this.showChangeUserModal}
                      showIPModifyModal = {this.showIPModifyModal}
                      onRemoveWhoIsPrivacy = {this.onRemoveWhoIsPrivacy}
                      onExpiredModify = {this.onExpiredModify}
                      handleHostingConfig = {this.handleHostingConfig}
                      onSuspendServiceExpired = {this.onSuspendServiceExpired}
                      onSuspendServiceManual = {this.onSuspendServiceManual}
                      onFinishTransfer = {this.onFinishTransfer}
                      userProfile = {userProfile}
                      role_path = {role_path}
                      dnsDirectUrl = {this.dnsDirectUrl}
                    />}
                  </tbody>
                </table>
              </div>
              {is_show_modal_change_user && <ChangeUserModal title="Chuyển đổi chủ sở hữu dịch vụ" show={is_show_modal_change_user} onHide={this.hideModal} userProductId={user_product_selected.id}></ChangeUserModal>}
              {is_show_ip_modify_modal && <IPModifyModal title="Chỉnh Sửa IP" show={is_show_ip_modify_modal} onHide={this.hideModal} ipProduct={user_product_selected} ipType={ip_type}></IPModifyModal>}
              {is_show_expired_date_modal && <ExpiredModifyModal title="Chỉnh Sửa Ngày Hết Hạn Dịch Vụ" show={is_show_expired_date_modal} userProduct={user_product_selected} onHide={this.hideModal}></ExpiredModifyModal>}
              {is_show_suspend_service_expired_modal && <SuspendServiceExpiredModal title="Suspend Dịch Vụ Hết Hạn" show={is_show_suspend_service_expired_modal} userProduct={user_product_selected} onHide={this.hideModal}/>}
              {is_show_suspend_manual_modal && <SuspendManualModal title="Suspend Manual" show={is_show_suspend_manual_modal} userProduct={user_product_selected} onHide={this.hideModal}/>}
              {is_show_finish_transfer_modal && <FinishTransferModal title="Hoàn Tất Transfer Tên Miền" show={is_show_finish_transfer_modal} userProduct={user_product_selected} onHide={this.hideModal}/>}
            </div>
            {userProfile && <Pagination query={table_query} data={table_data} handle={this.gotoPage}/>}
          </div>
        </div>
      </React.Fragment>
    )
  }
}

const ServicePageWrapper = reduxForm({
  form: 'ServicePage',
  destroyOnUnmount: true,
  enableReinitialize: true,
})(ServicePage);

export default (connect(mapState, mapDispatch))(withRouter(ServicePageWrapper));
